// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.left-section {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    position: relative;
    background-color: #f5f6f6;
}

.left-section:before {
    content: '';
    position: absolute;
    top: 5px;
    left: 0;
    right: 0;
    height: 20px;
    background: none;
    border-top: 4px solid #003c4f;
    border-radius: 10px 10px 0 0;
    transform: scaleY(0.5);
    z-index: 1;
}

.left-tabs-container {
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #ddd;
    width: 100%;
    margin: 15px 0 0 0;
    padding: 0;
    border-radius: 10px 10px 0 0;
    flex-shrink: 0;
}

.left-tab {
    flex: 1 1;
    padding: 10px 15px;
    border: none;
    border-bottom: 3px solid transparent;
    cursor: pointer;
    transition: all 0.3s ease;
    margin: 0;
    text-align: center;
    border-radius: 10px 10px 0 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    background: none;
    color: #333;
    font-size: 14px;
}

.left-tab:hover {
    background-color: #e0e0e0;
}

.left-tab.active {
    border-bottom-color: #003c4f;
    background-color: #f5f6f6;
    font-weight: 500;
}

.left-tab-content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    background-color: #f5f6f6;
    margin-top: 10px;
    border-radius: 0 0 10px 10px;
    overflow: hidden;
    height: calc(100vh - 100px);
    width: 100%;
}

.scrollable-content {
    flex: 1 1;
    overflow-y: auto;
    padding: 15px;
}

.prompts-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.prompt-item.selected {
    background-color: #e6f3ff;
    border-left: 4px solid #1a75ff;
    transform: translateX(2px);
}

.prompt-item {
    background: white;
    padding: 15px 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    color: #333;
    font-size: 14px;
    line-height: 1.5;
    transition: all 0.3s ease;
    text-align: left;
    border-left: 4px solid #003c4f;
    word-wrap: break-word;
    cursor: pointer;
    position: relative;
}

.prompt-item:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    background-color: #f8f8f8;
}

.prompt-item:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.deeper-questions-container {
    counter-reset: question;
}

.deeper-questions-list {
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding: 10px;
}

.deeper-question-item {
    background: white;
    padding: 15px 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    border-left: 4px solid #003c4f;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    position: relative;
}

.deeper-question-item:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    background-color: #f8f8f8;
}

.deeper-question-item:active {
    transform: translateY(0);
    background-color: #f0f0f0;
}

.question-number {
    font-weight: 600;
    color: #003c4f;
    margin-bottom: 8px;
    font-size: 14px;
}

.question-content {
    color: #333;
    font-size: 14px;
    line-height: 1.6;
    text-align: justify;
}

.copy-message {
    position: absolute;
    bottom: 10px;
    right: 20px;
    background-color: rgba(0, 60, 79, 0.9);
    color: #fff;
    padding: 5px 10px;
    border-radius: 5px;
    font-size: 12px;
    animation: fadeOut 2s forwards;
}

@keyframes fadeOut {
    0% { opacity: 1; }
    80% { opacity: 1; }
    100% { opacity: 0; }
}`, "",{"version":3,"sources":["webpack://./src/components/LeftTabs/LeftTabs.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,6BAA6B;IAC7B,4BAA4B;IAC5B,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;IAC7B,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,yBAAyB;IACzB,SAAS;IACT,kBAAkB;IAClB,4BAA4B;IAC5B,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;IAC5B,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,4BAA4B;IAC5B,gBAAgB;IAChB,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,sCAAsC;IACtC,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,8BAA8B;IAC9B,qBAAqB;IACrB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,qCAAqC;IACrC,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,sCAAsC;AAC1C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,sCAAsC;IACtC,8BAA8B;IAC9B,gCAAgC;IAChC,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,qCAAqC;IACrC,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,sCAAsC;IACtC,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,KAAK,UAAU,EAAE;IACjB,MAAM,UAAU,EAAE;IAClB,OAAO,UAAU,EAAE;AACvB","sourcesContent":[".left-section {\r\n    width: 100%;\r\n    height: 100vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n    position: relative;\r\n    background-color: #f5f6f6;\r\n}\r\n\r\n.left-section:before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 5px;\r\n    left: 0;\r\n    right: 0;\r\n    height: 20px;\r\n    background: none;\r\n    border-top: 4px solid #003c4f;\r\n    border-radius: 10px 10px 0 0;\r\n    transform: scaleY(0.5);\r\n    z-index: 1;\r\n}\r\n\r\n.left-tabs-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border-bottom: 1px solid #ddd;\r\n    width: 100%;\r\n    margin: 15px 0 0 0;\r\n    padding: 0;\r\n    border-radius: 10px 10px 0 0;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.left-tab {\r\n    flex: 1;\r\n    padding: 10px 15px;\r\n    border: none;\r\n    border-bottom: 3px solid transparent;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    margin: 0;\r\n    text-align: center;\r\n    border-radius: 10px 10px 0 0;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    background: none;\r\n    color: #333;\r\n    font-size: 14px;\r\n}\r\n\r\n.left-tab:hover {\r\n    background-color: #e0e0e0;\r\n}\r\n\r\n.left-tab.active {\r\n    border-bottom-color: #003c4f;\r\n    background-color: #f5f6f6;\r\n    font-weight: 500;\r\n}\r\n\r\n.left-tab-content {\r\n    flex-grow: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    background-color: #f5f6f6;\r\n    margin-top: 10px;\r\n    border-radius: 0 0 10px 10px;\r\n    overflow: hidden;\r\n    height: calc(100vh - 100px);\r\n    width: 100%;\r\n}\r\n\r\n.scrollable-content {\r\n    flex: 1;\r\n    overflow-y: auto;\r\n    padding: 15px;\r\n}\r\n\r\n.prompts-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 12px;\r\n}\r\n\r\n.prompt-item.selected {\r\n    background-color: #e6f3ff;\r\n    border-left: 4px solid #1a75ff;\r\n    transform: translateX(2px);\r\n}\r\n\r\n.prompt-item {\r\n    background: white;\r\n    padding: 15px 20px;\r\n    border-radius: 8px;\r\n    box-shadow: 0 2px 4px rgba(0,0,0,0.05);\r\n    color: #333;\r\n    font-size: 14px;\r\n    line-height: 1.5;\r\n    transition: all 0.3s ease;\r\n    text-align: left;\r\n    border-left: 4px solid #003c4f;\r\n    word-wrap: break-word;\r\n    cursor: pointer;\r\n    position: relative;\r\n}\r\n\r\n.prompt-item:hover {\r\n    transform: translateY(-1px);\r\n    box-shadow: 0 4px 6px rgba(0,0,0,0.1);\r\n    background-color: #f8f8f8;\r\n}\r\n\r\n.prompt-item:active {\r\n    transform: translateY(0);\r\n    box-shadow: 0 2px 4px rgba(0,0,0,0.05);\r\n}\r\n\r\n.deeper-questions-container {\r\n    counter-reset: question;\r\n}\r\n\r\n.deeper-questions-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 15px;\r\n    padding: 10px;\r\n}\r\n\r\n.deeper-question-item {\r\n    background: white;\r\n    padding: 15px 20px;\r\n    border-radius: 8px;\r\n    box-shadow: 0 2px 4px rgba(0,0,0,0.05);\r\n    border-left: 4px solid #003c4f;\r\n    transition: all 0.2s ease-in-out;\r\n    cursor: pointer;\r\n    user-select: none;\r\n    position: relative;\r\n}\r\n\r\n.deeper-question-item:hover {\r\n    transform: translateY(-1px);\r\n    box-shadow: 0 4px 6px rgba(0,0,0,0.1);\r\n    background-color: #f8f8f8;\r\n}\r\n\r\n.deeper-question-item:active {\r\n    transform: translateY(0);\r\n    background-color: #f0f0f0;\r\n}\r\n\r\n.question-number {\r\n    font-weight: 600;\r\n    color: #003c4f;\r\n    margin-bottom: 8px;\r\n    font-size: 14px;\r\n}\r\n\r\n.question-content {\r\n    color: #333;\r\n    font-size: 14px;\r\n    line-height: 1.6;\r\n    text-align: justify;\r\n}\r\n\r\n.copy-message {\r\n    position: absolute;\r\n    bottom: 10px;\r\n    right: 20px;\r\n    background-color: rgba(0, 60, 79, 0.9);\r\n    color: #fff;\r\n    padding: 5px 10px;\r\n    border-radius: 5px;\r\n    font-size: 12px;\r\n    animation: fadeOut 2s forwards;\r\n}\r\n\r\n@keyframes fadeOut {\r\n    0% { opacity: 1; }\r\n    80% { opacity: 1; }\r\n    100% { opacity: 0; }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
